import helpNoAuth from './helpNoAuth';
import noAuth from './noAuth';
import noAuthWithJava from './noAuthWithJava';

let promoRoutes = [];

promoRoutes = promoRoutes.concat(
    //General
    noAuth,
    //noAuth
    noAuthWithJava,
    helpNoAuth,
);
export default promoRoutes;
